import { Injectable } from "@angular/core";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { HttpClient } from "@angular/common/http";
import { retry } from "rxjs/operators";
import { Observable } from "rxjs";
import { FlagValidator } from "src/app/shared/enumeraciones/flag-validator.enum";

@Injectable()
export class SuspensionService
  implements RequestCRUD<any, ResponseServiceModel> {
  private API_URL;

  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  update(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  create(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getEstadosRNT(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/EstadosRnt/BuscarPorModulo?modulo_busqueda=${entry.tipo_estado}`
      )
      .pipe(retry(2));
  }
}
